import { render, staticRenderFns } from "./B2cStoreItemDetail.vue?vue&type=template&id=17d84a1a&scoped=true&"
import script from "./B2cStoreItemDetail.vue?vue&type=script&lang=js&"
export * from "./B2cStoreItemDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17d84a1a",
  null
  
)

export default component.exports